
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

import { sharedState } from '../state';
import { getFieldNameFromVModelProperty } from '../util/component_util';

@Component({
    components: { ValidationProvider },
})
export default class SelectField extends Vue {
    @Prop(String) readonly name!: string;
    @Prop(String) readonly value!: string;
    @Prop(String) readonly dataCy!: string;
    @Prop(String) readonly labelPosition!: string;
    @Prop(String) readonly readonlyClass!: string;
    @Prop(Array) readonly options!: { id: string | undefined; label: string }[];
    @Prop(Boolean) readonly disabled!: string;
    @Prop(Boolean) readonly readonly!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly horizontal!: boolean;
    @Prop(Boolean) readonly expanded!: boolean;
    @Prop(Boolean) readonly hideLabel!: boolean;
    @Prop(Number) readonly width!: number;

    shared = sharedState;
    local = {
        value: undefined as string | undefined,
    };

    async mounted() {
        await this.modelValueChange(this.value);
    }

    @Watch('value')
    async modelValueChange(newValue: string) {
        this.local.value = newValue;
    }

    @Watch('local.value')
    async inputValueChange(newValue: string) {
        this.$emit('input', newValue);
    }

    getFieldLabel(): string {
        if (this.hideLabel) {
            return '';
        } else {
            return this.$t(this.getFieldName() ? 'field.' + this.getFieldName() : '').toString();
        }
    }

    getLabel(id: string) {
        if (this.options === undefined) {
            return '';
        }
        const filtered = this.options.filter((o) => o.id === id);
        if (filtered.length > 0) {
            return filtered[0].label;
        } else {
            return '';
        }
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }
}
